<template>
    <app-modal-view>
        <template #header>
            <div class="lb-project-modal-header">
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <p
                                v-t="'Dashboard.invite_users'"
                                class="has-text-weight-bold is-size-5"
                            ></p>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item buttons">
                            <button
                                v-t="'Buttons.save'"
                                :disabled="!emails.length"
                                :class="{ 'is-loading': isLoading }"
                                class="button is-primary"
                                @click="sendInvitations"
                            />
                            <button
                                v-t="'Buttons.cancel'"
                                class="button is-dark"
                                @click="$emit('close')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <p
                v-t="'Dashboard.title_invite_with_email'"
                class="title is-size-6"
            ></p>
            <div class="field">
                <label v-t="'Labels.email'" class="label"></label>
                <div class="control">
                    <InputTags v-model="emails" :validate="'email'" />
                </div>
                <p v-t="'Dashboard.user_invite_help_email'" class="help"></p>
            </div>
            <p
                v-t="'Dashboard.title_invite_with_csv'"
                class="title is-size-6 pt-5"
            ></p>
            <div class="field">
                <div class="control">
                    <div class="file is-primary">
                        <label class="file-label">
                            <input
                                class="file-input"
                                type="file"
                                accept=".csv"
                                name="resume"
                                @input="readCSV"
                            />
                            <span class="file-cta">
                                <span
                                    v-t="'Buttons.upload_file'"
                                    class="file-label"
                                >
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
                <p class="help pt-4">
                    {{ $t('Dashboard.user_invite_help_csv')}}
                    <a href="/samples/invite_users_sample.csv" target="_blank" class="link">{{ $t('Dashboard.user_invite_help_csv_sample') }}</a>
                </p>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import InputTags from '@/components/InputTags';
import { inviteSchoolMembers } from '@/services/API';
import { validators } from '@/lib/helpers';

export default {
    components: {
        AppModalView,
        InputTags,
    },
    data() {
        return {
            emails: [],
            isLoading: false,
            readingFile: false,
        };
    },
    methods: {
        async sendInvitations() {
            this.isLoading = true;
            let localeToSend = this.$i18n.locale;
            if (localeToSend=='ca-ES') {
                localeToSend = "ca_ES";
            }
            let result = await inviteSchoolMembers({
                emails: this.emails,
                lang: localeToSend
            })
                .then(() => {
                    this.emails = [];
                    this.$emit('close');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        readCSV(ev) {
            this.readingFile = true;
            var reader = new FileReader();
            reader.onload = () => {
                this.readingFile = false;
                this.emails = reader.result.split('\n').filter((email) => {
                    console.log(email)
                    return validators.email.test(email);
                });
            };
            // console.log(this.emails);
            reader.onerror = () => {
                this.readingFile = false;
            };
            reader.readAsText(ev.target.files[0]);
        },
    },
};
</script>

<style></style>
